import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { MdPestControl } from "react-icons/md";
import { useSelector } from "react-redux";

const ViewWorkforce = () => {
  const userRole = useSelector((store) => store.login?.user?.Role);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/pestDisease/getPestDiseaseById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <MdPestControl className="me-2" style={{ color: "brown" }} />
                  View Pest/Diesease
                </h2>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="card">
                <div class="table-responsive">
                  <table class="table table-vcenter card-table table-striped">
                    <thead>
                      <tr>
                        <th>Specification</th>
                        <th>Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data && (
                        <tr>
                          <td>Name</td>
                          <td>{(data?.diseasesName || "N/A").toUpperCase()}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Image</td>
                          <td>
                            {data?.image ? (
                              <LazyImageComponent
                                width="10%"
                                src={data?.image}
                                alt={"image"}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Type of disease</td>
                          <td>
                            {(data?.typeOfDiseases || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Description</td>
                          <td>{(data?.description || "N/A").toUpperCase()}</td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan={2}>
                          <h3 className="m-0">Basic pest control:</h3>
                        </td>
                      </tr>

                      {data && (
                        <tr>
                          <td>Product To Use</td>
                          <td>{(data?.productToUse || "N/A").toUpperCase()}</td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Product Photo</td>
                          <td>
                            {data?.productPhoto ? (
                              <LazyImageComponent
                                width="10%"
                                src={data?.productPhoto}
                                alt={"productPhoto"}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Product Link</td>
                          <td>
                            {data?.productLink ? (
                              <a
                                href={data?.productLink}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {data?.productLink}
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Usage Of Product</td>
                          <td>
                            {(data?.usageOfProduct || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan={2}>
                          <h3 className="m-0">Moderate pest control:</h3>
                        </td>
                      </tr>
                      {data && (
                        <tr>
                          <td>Product To Use</td>
                          <td>
                            {(
                              data?.productToUseModerate || "N/A"
                            ).toUpperCase()}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Product Photo</td>
                          <td>
                            {data?.productPhotoModerate ? (
                              <LazyImageComponent
                                width="10%"
                                src={data?.productPhotoModerate}
                                alt={"productPhoto"}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Product Link</td>
                          <td>
                            {data?.productLinkModerate ? (
                              <a
                                href={data?.productLinkModerate}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {data?.productLinkModerate}
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Usage Of Product</td>
                          <td>
                            {(
                              data?.usageOfProductModerate || "N/A"
                            ).toUpperCase()}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan={2}>
                          <h3 className="m-0">Wild-Spred pest control:</h3>
                        </td>
                      </tr>
                      {data && (
                        <tr>
                          <td>Product To Use</td>
                          <td>
                            {(data?.productToUseWild || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Product Photo</td>
                          <td>
                            {data?.productPhotoWild ? (
                              <LazyImageComponent
                                width="10%"
                                src={data?.productPhotoWild}
                                alt={"productPhoto"}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Product Link</td>
                          <td>
                            {data?.productLinkWild ? (
                              <a
                                href={data?.productLinkWild}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {data?.productLinkWild}
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Usage Of Product</td>
                          <td>
                            {(data?.usageOfProductWild || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <td colSpan={2}>
                          <h3 className="m-0">Organic pest control:</h3>
                        </td>
                      </tr>
                      {data && (
                        <tr>
                          <td>Product To Use</td>
                          <td>
                            {(data?.productToUseOrganic || "N/A").toUpperCase()}
                          </td>
                        </tr>
                      )}
                      {data && (
                        <tr>
                          <td>Product Photo</td>
                          <td>
                            {data?.productPhotoOrganic ? (
                              <LazyImageComponent
                                width="10%"
                                src={data?.productPhotoOrganic}
                                alt={"productPhoto"}
                              />
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Product Link</td>
                          <td>
                            {data?.productLinkOrganic ? (
                              <a
                                href={data?.productLinkOrganic}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {data?.productLinkOrganic}
                              </a>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      )}

                      {data && (
                        <tr>
                          <td>Usage Of Product</td>
                          <td>
                            {(
                              data?.usageOfProductOrganic || "N/A"
                            ).toUpperCase()}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    {userRole !== process.env.REACT_APP_ROLE_CLIENT && (
                      <SimpleButton
                        buttonText="Edit Pest/Disease"
                        href={`/agronomy-pest-disease/edit/${id}`}
                      />
                    )}
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewWorkforce;
